import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deliveryApi,
  type UpdateDeliveryZonePayload,
} from "@/lib/admin-api/delivery";

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

const ZONES_KEY = "admin-delivery-zones";

// ---------------------------------------------------------------------------
// Hooks
// ---------------------------------------------------------------------------

export function useDeliveryZones() {
  return useQuery({
    queryKey: [ZONES_KEY],
    queryFn: () => deliveryApi.zones.list(),
    staleTime: 30_000,
  });
}

export function useUpdateDeliveryZone() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateDeliveryZonePayload;
    }) => deliveryApi.zones.update(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ZONES_KEY] });
    },
  });
}
